import React from "react";

type Props = {
  className?: string
}

export const NotFoundIcon = ({className}: Props) => {
  return (
    <svg className={className} width="592" height="230" viewBox="0 0 592 230" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M297.893 0C250.546 0 212.168 38.3823 212.168 85.735V144.265C212.168 191.618 250.546 230 297.893 230C345.24 230 383.618 191.618 383.618 144.265V85.735C383.618 38.3823 345.24 0 297.893 0ZM338.374 144.265C338.374 166.588 320.213 184.751 297.893 184.751C275.573 184.751 257.412 166.588 257.412 144.265V85.735C257.412 63.4121 275.573 45.249 297.893 45.249C320.213 45.249 338.374 63.4121 338.374 85.735V144.265Z" fill="#0166FF"/>
      <path d="M561.877 0V230H515.88V46.0032L561.877 0Z" fill="#0166FF"/>
      <path d="M442.855 138.002H592V183.997H414.867L442.855 138.002Z" fill="#0166FF"/>
      <path d="M398.389 130.111L414.867 183.997L561.877 0H505.894L398.389 130.111Z" fill="#0166FF"/>
      <path d="M163.488 0V230H117.49V46.0032L163.488 0Z" fill="#0166FF"/>
      <path d="M44.4657 138.002H193.611V183.997H16.4782L44.4657 138.002Z" fill="#0166FF"/>
      <path d="M0 130.111L16.4782 183.997L163.488 0H107.513L0 130.111Z" fill="#0166FF"/>
    </svg>
  );
}